import React from "react";
import { CheckCircle, XCircle } from "react-bootstrap-icons";
import { Card, Row, Col, Button } from "react-bootstrap";

const cardData = [
  {
    id: 1,
    title: "Data Analytics Tools -171",
    description: "Digital Learning",
    digitalLearning: true,
  },
  {
    id: 2,
    title: "Cloud Computing Essentials",
    description: "Digital Learning",
    digitalLearning: false,
  },
  {
    id: 3,
    title: "Machine Learning Basics",
    description: "Digital Learning",
    digitalLearning: true,
  },
  {
    id: 4,
    title: "Data Analytics Tools -171",
    description: "Digital Learning",
    digitalLearning: true, 
  },
  {
    id: 5,
    title: "Cloud Computing Essentials",
    description: "Digital Learning",
    digitalLearning: true, 
  },
  {
    id: 6,
    title: "Machine Learning Basics",
    description: "Digital Learning",
    digitalLearning: false, 
  },
];

const DigitalLearningModules = () => {
  return (
    <div className="p-4">
      <div className="text-center mb-3">
        <h5 className="mb-1">Digital Learning Modules</h5>
        <p className="text-danger mb-0" style={{ fontSize: "0.875rem" }}>
          *To generate Digital Learning certificates, ensure digital learning
          process completed 100%.
        </p>
        <Row xs={1} sm={2} md={3} className="g-4">
          {cardData.map((card) => (
            <Col key={card.id}>
              <Card className="w-100 rounded-2xl p-0 shadow-sm hover-effect mt-2" style={{ height: "150px" }}>
                <Card.Header className="d-flex justify-content-between align-items-center pb-0 border-0">
                  <div>
                    <h3 className="fs-4 fs-bold mb-1">{card.title}</h3>
                    <p className="text-sm text-dark text-start">
                      {card.description}
                    </p>
                  </div>
                  <div className="h-8 w-8 rounded-circle d-flex justify-content-center align-items-center">
                    {card.digitalLearning ? (
                      <CheckCircle className="fs-4 text-success" />
                    ) : (
                      <XCircle className="fs-4 text-danger" />
                    )}
                  </div>
                </Card.Header>
                <Card.Body className="pt-0 pb-0">
                  {card.digitalLearning && (
                    <Button
                      className="w-100 py-2 text-sm rounded-lg"
                      style={{ border: "none" }}
                    >
                      Generate Certificate
                    </Button>
                  )}
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default DigitalLearningModules;
